import {
    Box,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import searchIcon from "../../assets/images/search-normal.svg";
import CustomTable from "../customTable/CustomTable";
import {Pagination} from "@material-ui/lab";
import {useEffect, useState} from "react";
import * as React from "react";
import calender from '../../assets/images/calender-1.svg'
import RegisterNewDeposit from "../RegisterNewDeposit/RegisterNewDeposit";
import DateSelection from "../DateSelection/DateSelection";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {TransactionsService} from "./TransactionsService";
import moment from "jalali-moment";
import RegisterEditDeposit from "../RegisterEditDeposit/RegisterNewDeposit";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";
import {preparePositiveNegativeNumberCell, prepareStatusCell} from "../../utils/PrepareTableCellStyle";
import {DialogSize, RaikoCustomTooltip} from "@moeindal/base-raiko-panel-components";
import DefaultDialogPage from "../defaultDialogPage/DefaultDialogPage";
import TransactionsDetail from "./TransactionsDetail";
import {css} from "@emotion/css";
import TransactionReceipt from "./TransactionReceipt";

const TransactionsList = () => {
    let page = 0

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new TransactionsService(fundID, token, snackbar, loading)

    const [pageCount, setPageCount] = useState(0);
    const [itemCount, setItemCount] = useState(0);

    const [transactionListData, setTransactionListData] = useState([]);
    const [needRefresh, setNeedRefresh] = useState(false);

    const [filterText, setFilterText] = useState("");
    const [filterSelectedValue, setFilterSelectedValue] = useState("owner-full-name");

    const [dateFilterSelected, setDateFilterSelected] = useState("");
    const [dateSubmittedFilterSelected, setDateSubmittedFilterSelected] = useState("");
    const [payerType, setPayerType] = useState("");

    useEffect(() => {
        if (typeof service !== 'undefined') {
            getListDataFromServer()
        }
    }, [dateFilterSelected, dateSubmittedFilterSelected, payerType])


    function getListDataFromServer(
        filter = filterText,
        dateFilter = dateFilterSelected,
        dateSubmittedFilter = dateSubmittedFilterSelected,
        filterType = filterSelectedValue,
        payerTypeFilter = payerType
    ) {
        loading(setLoadingStateDispatch(true))

        service.getTransactionList(
            fundID,
            page,
            prepareFilter(filter, dateFilter,dateSubmittedFilter, filterType, payerTypeFilter)
        ).then(response => {
            setTransactionList(response)
            loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در دریافت اطلاعات تراکنش ها", snackbar, loading)
        })
    }

    function setTransactionList(transactionsData) {

        setItemCount(transactionsData.numberOfItems)
        setPageCount(transactionsData.totalPage)
        setTransactionListData([])

        transactionsData.data.map((item, index) => {
            setTransactionListData((prevState => [...prevState,
                prepareGroupsJsonList(
                    item.id,
                    (page * 20) + index + 1,
                    item.depositAccountNumber,
                    item.ownerFirstName,
                    item.ownerLastName,
                    item.ownerNationalCode,
                    item.amount,
                    item.currentBalance,
                    item.kind,
                    item.depositedAt,
                    item.hasBeenDelayed,
                    item.enabled,
                    item.depositedByManager,
                    item.depositedByMember,
                    item.receiptUrl,
                )
            ]))
        })

    }

    const [receiptDialogState, setReceiptDialogState] = useState(false)
    const [receiptItemInfo, setReceiptItemInfo] = useState({});

    function handleOpenReceiptDialog() {
        setReceiptDialogState(true)
    }

    function handleCloseReceiptDialog() {
        setReceiptDialogState(false)
        setReceiptItemInfo({})
    }


    function prepareGroupsJsonList(id, number, depositAccountNumber, ownerFirstName,
                                   ownerLastName, ownerNationalCode, amount, currentBalance, kind,
                                   depositedAt, hasBeenDelayed, enabled, depositedByManager, depositedByMember, receiptUrl) {
        return {
            id: id,
            number: number,
            depositAccountNumber: depositAccountNumber,
            fullName: `${ownerFirstName} ${ownerLastName}`,
            nationalCode: ownerNationalCode,
            depositedAt: depositedAt ? moment(depositedAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD') : "-",
            hasBeenDelayed: hasBeenDelayed ? <span className="bg_deActive_state">دارد</span> :
                <span className="bg_active_state">ندارد</span>,
            kind: kind === "MANAGER_DEPOSIT" ? "ادمین" : "کاربر",
            depositedBy:
                depositedByManager && depositedByManager !== "" ? depositedByManager :
                    depositedByMember && depositedByMember !== "" ? depositedByMember : "-",
            balance: preparePositiveNegativeNumberCell(amount),
            currentBalance: preparePositiveNegativeNumberCell(currentBalance),
            status: prepareStatusCell(enabled),
            access: <RaikoCustomTooltip title={"رسید تراکنش"}>
                <div
                    className={`
                    ${css`width: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;`} ic-receipt`}

                    onClick={e => {
                        e.stopPropagation()
                        e.preventDefault()
                        handleOpenReceiptDialog()
                        setReceiptItemInfo({id, receiptUrl})
                    }}
                />
            </RaikoCustomTooltip>
        }
    }

    const handleChange = (event, value) => {
        page = value - 1
        getListDataFromServer()
    };
    //modal-start
    const [openDialog, setOpenDialog] = useState(false)
    const openNewTransactions = () => {
        setOpenDialog(true);
    };
    const handleClose = () => {
        setOpenDialog(false);
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }

    const [openEditTransDialog, setOpenEditTransDialog] = useState(false)
    const openEditTransactions = () => {
        setOpenEditTransDialog(true);
    };
    const handleCloseEditTransaction = () => {
        setOpenEditTransDialog(false);
        if (needRefresh) {
            setNeedRefresh(false)
            getListDataFromServer()
        }
    }

    //modal-end
    // date-selection-dialog-start
    const [openDateSelectionDialog, setOpenDateSelectionDialog] = useState(false)
    const handleClickOpenDateDialog = () => {
        setOpenDateSelectionDialog(true);
    };
    const handleCloseOpenDateDialog = () => {
        setOpenDateSelectionDialog(false);
    }

    function prepareFilter(filterText, date,dateSubmitted, filterType = filterSelectedValue, payerTypeFilter) {
        let filterJson = filterType === "owner-full-name" ? {
            "owner-full-name": filterText,
        } : filterType === "owner-national-code" ? {
            "owner-national-code": filterText
        } : filterType === "deposit-account-number" ? {
            "deposit-account-number": filterText
        } : filterType === "group-name" ? {
            "group-name": filterText
        } : {
            "groupCode": filterText
        }

        if (payerTypeFilter && payerTypeFilter.length > 0 && payerTypeFilter !== "ALL")
            filterJson = {
                ...filterJson,
                "depositor-type": payerTypeFilter
            }

        return {
            "deposited-at": date ? moment.from(date, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
            "submitted-at": dateSubmitted ? moment.from(dateSubmitted, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD') : "",
            ...filterJson
        }
    }


    const [transactionDetailOpenDialog, setTransactionDetailOpenDialog] = useState(false)
    const [selectedItemId, setSelectedItemId] = useState(-1);
    const showEventsContent = (rowId) => {
        setSelectedItemId(rowId)
    }

    function handleOpenTransactionDialog() {
        setTransactionDetailOpenDialog(true)
    }

    function handleCloseTransactionDialog() {
        setTransactionDetailOpenDialog(false)
        setSelectedItemId(-1)
    }

    useEffect(() => {
        if (selectedItemId && selectedItemId !== -1)
            handleOpenTransactionDialog()
    }, [selectedItemId]);


    return (
        <>

            <DefaultDialogPage
                open={receiptDialogState}
                onClose={handleCloseReceiptDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"رسید تراکنش"}
            >
                <TransactionReceipt
                    info={receiptItemInfo}
                    handleUpdateTable={_ => {
                        getListDataFromServer()
                    }}/>
            </DefaultDialogPage>


            <DefaultDialogPage
                onClose={handleCloseTransactionDialog}
                open={transactionDetailOpenDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                pageTitle={"ویرایش تراکنش"}
            >
                <TransactionsDetail
                    id={selectedItemId}
                    handleUpdateTable={_ => {
                        handleCloseTransactionDialog()
                        getListDataFromServer()
                    }}
                />
            </DefaultDialogPage>

            {
                <RegisterNewDeposit
                    openDialog={openDialog}
                    handleClose={handleClose}
                    needRefresh={setNeedRefresh}
                />
            }
            {
                <RegisterEditDeposit
                    openDialog={openEditTransDialog}
                    handleClose={handleCloseEditTransaction}
                    needRefresh={setNeedRefresh}
                />
            }

            <DateSelection
                openDateSelectionDialog={openDateSelectionDialog}
                handleCloseOpenDateDialog={handleCloseOpenDateDialog}
                setFilter={(date, submittedDate, payer) => {
                    setDateFilterSelected(date)
                    setPayerType(payer)
                    setDateSubmittedFilterSelected(submittedDate)

                }}
            />


            <section className='pageContainer' style={{overflowY: 'hidden'}}>

                <Box className="d-flex flex-row w-100"
                     sx={{
                         margin: '1rem 0 1.2rem 0',
                         justifyContent: 'center',
                         alignContent: 'center',
                         alignItems: 'center'
                     }}>
                    <section className='d-flex flex-column flex-nowrap flex-grow-1'
                             style={{alignItems: 'start'}}>
                        <Typography variant={"h5"}>
                            تراکنشات واریز پس انداز
                        </Typography>
                        <section className="d-flex flex-row flex-nowrap">
                            {itemCount > 0 ?
                                <Typography style={{margin: "8px 8px 0 8px"}} variant={"caption"}>
                                    {" " + itemCount + " تراکنش ثبت شده "}
                                </Typography> :
                                ''}
                            {dateFilterSelected ?
                                <Typography style={{margin: "8px 2px 0 8px"}} variant={"caption"}>
                                    {" در تاریخ  : " + dateFilterSelected + ""}
                                </Typography> : ""}
                            {dateSubmittedFilterSelected ?
                                <Typography style={{margin: "8px 2px 0 8px"}} variant={"caption"}>
                                    {" در تاریخ  : " + dateSubmittedFilterSelected + ""}
                                </Typography> : ""}
                            {payerType && payerType !== "ALL" ?
                                <Typography style={{margin: "8px 2px 0 8px"}} variant={"caption"}>
                                    {` توسط ${payerType === "MEMBER" ? "کاربر" : "ادمین"}`}
                                </Typography> : ""}


                        </section>
                    </section>
                    <section className="account-details-header-button-section">
                        <button className="btn-secondary" onClick={openEditTransactions}>ویرایش تراکنش گروهی</button>
                        <button className="btn-confirm" onClick={openNewTransactions}
                                style={{marginRight: "1rem"}}>تراکنش گروهی جدید
                        </button>
                    </section>
                </Box>
                <Box className="d-flex flex-row w-100 flex-wrap"
                     sx={{
                         margin: '0 0 1.2rem 0',
                         justifyContent: 'start',
                         alignContent: 'start',
                     }}>
                    <Grid xs={12} sm={12} md={8} lg={8} xl={8} className="w-100 p-2">
                        <TextField
                            value={filterText}
                            onChange={e => {
                                setFilterText(e.target.value)
                                getListDataFromServer(e.target.value)
                            }}
                            className="w-100"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <img src={searchIcon} alt=""/>
                                    </InputAdornment>
                                ),
                            }}
                            variant="outlined" label="جستجو"
                            placeholder="عبارت مورد نظر را وارد نمایید..."/>
                    </Grid>
                    <Grid xs={12} sm={12} md={4} lg={4} xl={4} className="d-flex flex-row flex-nowrap alignItemsCenter">
                        <FormControl variant="outlined" className="w-100" style={{flexGrow: "1"}}>
                            <InputLabel htmlFor="filled-age-native-simple">جستجو بر اساس</InputLabel>
                            <Select value={filterSelectedValue} onChange={e => {
                                setFilterSelectedValue(e.target.value)
                                getListDataFromServer(
                                    filterText,
                                    dateFilterSelected,
                                    dateSubmittedFilterSelected,
                                    e.target.value
                                )
                            }}
                                    label="جستجو بر اساس">
                                <option value={"owner-full-name"}>نام و نام خانوادگی</option>
                                <option value={"owner-national-code"}>کد ملی</option>
                                <option value={"group-name"}>نام گروه</option>
                                <option value={"groupCode"}>کد گروه</option>
                                <option value={"deposit-account-number"}>شماره حساب</option>
                            </Select>
                        </FormControl>

                        <button className="btn-date"
                                onClick={handleClickOpenDateDialog}>
                            <img src={calender} style={{height: "56px"}} alt=""/>
                        </button>

                    </Grid>
                </Box>
                <CustomTable
                    header={columns}
                    data={transactionListData}
                    rowClicked={showEventsContent}
                />
                <Box className="paginationContainer">
                    <Pagination
                        count={pageCount}
                        color="primary"
                        onChange={handleChange}
                        showFirstButton showLastButton/>
                </Box>
            </section>
        </>

    )
}
export default TransactionsList;


const columns = [
    {
        id: 'number',
        label: '#',
        align: 'right',

    },
    {
        id: 'fullName',
        label: 'نام و نام خانوادگی',
        align: 'right',
    },
    {
        id: 'nationalCode',
        label: 'کد ملی',
        align: 'right',
    },
    {
        id: 'depositAccountNumber',
        label: 'شناسه حساب',
        align: 'right',
    },
    {
        id: 'balance',
        label: 'مبلغ (ریال)',
        align: 'right',
    },
    {
        id: 'currentBalance',
        label: 'موجودی (ریال)',
        align: 'right',
    },
    {
        id: 'depositedAt',
        label: 'تاریخ پرداخت',
        align: 'right',
    },
    {
        id: 'kind',
        label: 'نوع واریز',
        align: 'right',
    },
    {
        id: 'depositedBy',
        label: 'واریز کننده',
        align: 'right',
    },
    {
        id: 'hasBeenDelayed',
        label: 'تاخیر',
        align: 'right',
    },
    {
        id: 'status',
        label: 'وضعیت',
        align: 'right',
    },
    {
        id: 'access',
        label: 'دسترسی',
        align: 'right',
    },
];